import { i as deleteProof, n as notifyPaid, r as get2, t as uploadProof } from "./uploadProof.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/external/payment/hooks/useDeleteProof.ts
const deleteProofMutationKey = () => [{ url: "/api/mdm/external/api/external/requests/:id/payment/proof" }];
function deleteProofMutationOptions(config = {}) {
	const mutationKey = deleteProofMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await deleteProof({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Удалить подтверждение оплаты (владелец, до уведомления)
* {@link /api/mdm/external/api/external/requests/:id/payment/proof}
*/
function useDeleteProof(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? deleteProofMutationKey();
	const baseOptions = deleteProofMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/external/payment/hooks/useGet2.ts
const get2QueryKey = ({ path }) => [{
	url: "/api/mdm/external/api/external/requests/:id/payment",
	params: path
}];
function get2QueryOptions({ path }, config = {}) {
	const queryKey = get2QueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await get2({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Данные оплаты по заявке (для заявителя)
* {@link /api/mdm/external/api/external/requests/:id/payment}
*/
function useGet2({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? get2QueryKey(resolvedParams);
	const queryResult = useQuery({
		...get2QueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/external/payment/hooks/useNotifyPaid.ts
const notifyPaidMutationKey = () => [{ url: "/api/mdm/external/api/external/requests/:id/payment/notify" }];
function notifyPaidMutationOptions(config = {}) {
	const mutationKey = notifyPaidMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await notifyPaid({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Уведомить об оплате (WAITING_PAYMENT → IN_REVIEW)
* {@link /api/mdm/external/api/external/requests/:id/payment/notify}
*/
function useNotifyPaid(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? notifyPaidMutationKey();
	const baseOptions = notifyPaidMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/external/payment/hooks/useUploadProof.ts
const uploadProofMutationKey = () => [{ url: "/api/mdm/external/api/external/requests/:id/payment/proof" }];
function uploadProofMutationOptions(config = {}) {
	const mutationKey = uploadProofMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await uploadProof({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Загрузить/заменить подтверждение оплаты (владелец, до уведомления)
* {@link /api/mdm/external/api/external/requests/:id/payment/proof}
*/
function useUploadProof(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? uploadProofMutationKey();
	const baseOptions = uploadProofMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { notifyPaidMutationOptions as a, get2QueryOptions as c, deleteProofMutationOptions as d, useDeleteProof as f, notifyPaidMutationKey as i, useGet2 as l, uploadProofMutationOptions as n, useNotifyPaid as o, useUploadProof as r, get2QueryKey as s, uploadProofMutationKey as t, deleteProofMutationKey as u };

//# sourceMappingURL=useUploadProof.js.map